export default __webpack_public_path__ + "static/media/1830.c7fbe8be.png";